<template>
  <div class="index">
    <!-- 首页轮播图 -->
    <div class="logo"><img src="../assets/img/index/1.png"></div>
    <mt-swipe :auto="4000" :style="{height: imgHeight+'px'}">
      <mt-swipe-item>
        <!-- <img v-if='state' src="../assets/img/home/B-2-min.jpg"  class="titleImg" @click="$router.push('/createProject')"> -->
       <router-link to="" @click.native="swiperone">
          <img ref='imgele' src="../assets/img/home/B-1-min.jpg" class="titleImg">
        </router-link>
        <!-- <p class="imgTitle">{{title}}</p> -->
      </mt-swipe-item>
      <mt-swipe-item>
        <!-- <img v-if='state' src="../assets/img/home/B-2-min.jpg" class="titleImg"> -->
        <router-link to="" @click.native="swipertwo">
          <img src="../assets/img/home/B-2-min.jpg" class="titleImg">
        </router-link>
        <!-- <p class="imgTitle">{{title}}</p> -->
      </mt-swipe-item>
      <mt-swipe-item>
        <a href="http://blog.yunzhitu.com/yunzhitu-case">
          <img src="../assets/img/home/B-3-min.jpg" class="titleImg">
        </a>
        <!-- <p class="imgTitle">{{title}}</p> -->
      </mt-swipe-item>
    </mt-swipe>
    <!-- 推荐人 -->
    <div class="recommend">
        <router-link class="recommendlist" to="/expertsrecommend">
            <img src="../assets/img/index/2.png" alt="">
            <p>专家推荐</p>
        </router-link>
        <router-link class="recommendlist" to="" @click.native="goPub">
            <img src="../assets/img/index/3.png" alt="">
            <p>优质项目</p>
        </router-link>
        <a class="recommendlist" href="http://blog.yunzhitu.com/yunzhitu-case/" target="_blank">
            <img src="../assets/img/index/4.png" alt="">
            <p>经典案例</p>
        </a>
        <a class="recommendlist" href="http://blog.yunzhitu.com/news/" target="_blank">
            <img src="../assets/img/index/5.png" alt="">
            <p>平台动态</p>
        </a>
    </div>
    <!-- 选择接需求还是发需求 -->
    <div class="selectbox">
        <h1 @click="goback()">为供需双方提供系信息对接平台</h1>
        <h6>一键触达、实时、高效的技术对接解决方案</h6>
        <div class="select">
            <div class="send">
                <p class="need">有需求 极速发布</p>
                <p class="introdce">一键提交用户需求，省时</p>
                <p class="introdce">专人完善需求资料，省力</p>
                <p class="introdce">微信实时查询进展，省心</p>
                <div class="btns">
                    <button type="button" @click="sendneed">我要发需求</button>
                </div>
            </div>
            <div class="send">
                <p class="need">懂技术 便捷接单</p>
                <p class="introdce">人工验证需求信息，真实有效</p>
                <p class="introdce">线上直连需求对象，拒绝中介</p>
                <p class="introdce">真实需求每日更新，实时高效</p>
                <div class="btns">
                    <button type="button" @click="goPub">我要接需求</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 专家 -->
    <div class="expertbox">
        <h1>这里都是行业内可信赖的专家</h1>
        <h6>每个专家都经过人工严格审核</h6>
        <div class="expertlist">
            <div class="listitem" >
                <img :src="httpurl+datalistone.photo" alt="">
                <p class="name">
                    {{nickname}}/{{datalistone.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistone.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in dataoneskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalisttwo.photo" alt="">
                <p class="name">
                    {{nicknametwo}}/{{datalisttwo.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalisttwo.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datatwoskills" :key="index">{{item}}</p>
                </div>
            </div>
           <div class="listitem" >
                <img :src="httpurl+datalistthree.photo" alt="">
                <p class="name">
                    {{nicknamethree}}/{{datalistthree.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistthree.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datathreeskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalistfour.photo" alt="">
                <p class="name">
                    {{nicknamefour}}/{{datalistfour.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistfour.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datafourskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalistfive.photo" alt="">
                <p class="name">
                    {{nicknamefive}}/{{datalistfive.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistfive.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datafiveskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalistsix.photo" alt="">
                <p class="name">
                    {{nicknamesix}}/{{datalistsix.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistsix.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datasixskills" :key="index">{{item}}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- 各种设计 -->
    <div class="designbox">
        <div class="pjt_type">
            <span v-for="types in types" :key="types.id" v-on:click="selected(types)" :class='{selected:typeSelect==types.name}' >{{types.name}}</span>
        </div>
        <!-- <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore"> -->
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <ul>
            <li v-for="(pjtList,index) in pjtList" :key="index">
                <div class="projectList"  v-on:click="toProjectDetail(pjtList)">
                    <div class="leftimg">
                        <img src="../assets/img/index/chanpin.jpg" alt="" v-if="typeSelect==='产品设计'">
                        <img src="../assets/img/index/jidian.jpg" alt="" v-if="typeSelect==='机电设计'">
                        <img src="../assets/img/index/jiemian.jpg" alt="" v-if="typeSelect==='界面设计'">
                        <img src="../assets/img/index/chengxu.jpg" alt="" v-if="typeSelect==='程序设计'">
                        <div class="recommend_Pjt">
                            <div class="bgimg" v-if="pjtList.status==4">招募中</div>
                            <div class="bgimg" v-if="pjtList.status==5">已关闭</div>
                            <div class="bgimg" v-if="pjtList.status==6">已合作</div>
                            <div class="bgimg" v-if="pjtList.status==7">进行中</div>
                            <div class="bgimg" v-if="pjtList.status==8">已完成</div>
                            <div class="bgimg" v-if="pjtList.status==9">已评价</div>
                        </div>
                    </div>
                    <div class="rightinfo">
                        <h1 style="-webkit-box-orient: vertical;">{{pjtList.title}}</h1>
                        <p class="money" v-if="pjtList.status==4">{{pjtList.prePrice}}</p>
                        <p class="money" v-else>{{pjtList.charge}}<span v-if="pjtList.charge">元</span></p>
                        <div class="people">
                            <span>推荐{{pjtList.countRecommender}}人</span><span>浏览{{pjtList.countVisit}}人</span>
                        </div>
                    </div>
                </div>
            </li>
          </ul>
        </van-list>
        <!-- </mt-loadmore> -->
    </div>

  </div>
</template>

<script>
import global from '../config/common'
import { Indicator } from 'mint-ui'
import bus from '../utiles/bus'
import Vue from 'vue'
export default {
  name: 'index',
  data () {
    return {
      httpurl:'http://oss.yunzhitu.com/',
      // titleImg: [{title: 'aaaa', url: require('../assets/img/home/B-1-min.jpg')}, {title: 'bbbb', url: require('../assets/img/home/B-2-min.jpg')}, {title: 'ccccc', url: require('../assets/img/home/B-3-min.jpg')}],
      imgUrl: [require('../assets/img/home/recommendPerson/1.jpg'), require('../assets/img/home/recommendPerson/2.jpg'), require('../assets/img/home/recommendPerson/3.jpg'), require('../assets/img/home/recommendPerson/4.jpg')],
      pjtLists: '',
      searchCondition: {
        pageNo:1,
        pageSize: '10'
      },
      allLoaded: false,
      scrollMode: 'auto',
      state: false,
      imgHeight: '',
      types: [],
      typeSelect: '机电设计',
      pjtType: '',
      pjtList: '',
      datalistone:'',
      nickname:'',
      dataoneskills:[],
      datalisttwo:'',
      nicknametwo:'',
      datatwoskills:[],
      datalistthree:'',
      nicknamethree:'',
      datathreeskills:[],
      datalistfour:'',
      nicknamefour:'',
      datafourskills:[],
      datalistfive:'',
      nicknamefive:'',
      datafiveskills:[],
      datalistsix:'',
      nicknamesix:'',
      datasixskills:[],
      loading: false,
      finished: false,
    }
  },
  created(){
    this.datalist()
    this.getimgurl()
  },
  mounted () {
    this.loadList()
    this.state = this.STATE.state.loginState
    this.getType()
  },
  methods: {
    onLoad: function () {
      let _this = this
      this.searchCondition.pageNo = this.searchCondition.pageNo + 1
      setTimeout(() => {
        this.axios.get('url/work/project/queryweixinprojectlists?type=' + this.pjtType + '&rows=20&page=' + this.searchCondition.pageNo)
        .then(function (res) {
          if(res){
            // 加载状态结束
            _this.loading = false;
            if(_this.searchCondition.pageNo==1){
              _this.pjtList = res.data
            }else{
              _this.pjtList = _this.pjtList.concat(res.data)
            }
            if (res.data.length <20) {
                _this.finished = true;
            }
          }
        }).catch(function (response) {
        })
      }, 500)
    },
    getimgurl:function(){
      let _this=this
      this.axios.get('url/user/imgHttpUrl.json')
      .then(function (res) {
        // _this.httpurl=res.data
        _this.STATE.state.httpimgurl = res.data
        Vue.prototype.$imgHttpUrl = res.data;
      })
    },
    datalist:function(){
      let _this = this
      this.axios.get('url/account/userInfo/getUserInformationById?id=3506')
      .then(function (res) {
        _this.datalistone=res.data
        _this.nickname=res.data.account.name
        _this.dataoneskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=2230')
      .then(function (res) {
        _this.datalisttwo=res.data
        _this.nicknametwo=res.data.account.name
        _this.datatwoskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=2581')
      .then(function (res) {
        _this.datalistthree=res.data
        _this.nicknamethree=res.data.account.name
        _this.datathreeskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=8302')
      .then(function (res) {
        _this.datalistfour=res.data
        _this.nicknamefour=res.data.account.name
        _this.datafourskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=8482')
      .then(function (res) {
        _this.datalistfive=res.data
        _this.nicknamefive=res.data.account.name
        _this.datafiveskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=5226')
      .then(function (res) {
        _this.datalistsix=res.data
        _this.nicknamesix=res.data.account.name
        _this.datasixskills=res.data.skills.split('@')
      })
    },
    swiperone:function () {
      if (this.STATE.state.loginState) {
        this.$router.push({path: '/createProject'})
        bus.$emit('routerBus', 'btnThree')
      } else {
        this.$router.push({name: 'login', params: {fromPath: '/createProject', icon: 'btnThree'}})
      }
    },
    swipertwo:function () {
      if (this.STATE.state.loginState) {
        this.$router.push({path: '/certification'})
        bus.$emit('routerBus', 'btnFive')
      } else {
        this.$router.push({name: 'login', params: {fromPath: '/certification', icon: 'btnFive'}})
        bus.$emit('routerBus', 'btnFive')
      }
    },
    goPub: function () {
      this.$router.push({path: '/project'})
      bus.$emit('routerBus', 'btnTwo')
    },
    sendneed: function () {
      if (this.STATE.state.loginState) {
        this.$router.push({path: '/createProject'})
        bus.$emit('routerBus', 'btnThree')
      } else {
        this.$router.push({name: 'login', params: {fromPath: '/createProject', icon: 'btnThree'}})
        bus.$emit('routerBus', 'btnFive')
      }
    },
    selected: function (types) {
      this.searchCondition.pageNo = 1
      this.typeSelect = types.name
      this.pjtType = types.id
      this.loadPageList()
    },
    getType: function () {
      let _this = this
      this.axios.get('url/work/project/queryweixinprojectlistType')
      .then(function (res) {
        _this.types = _this.types.concat(res.data)
        _this.pjtType = res.data[0].id
        _this.loadPageList()
      })
    },
    loadPageList: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/work/project/queryweixinprojectlists?type=' + this.pjtType + '&rows=20&page=1')
      .then(function (res) {
        Indicator.close()
        _this.pjtList = res.data
        if (res.data.length < 20) {
          _this.finished = true
        }else{
          _this.finished = false
        }
        // _this.geshu = res.data.length
      }).catch(function (response) {
        Indicator.close()
      })
    },
    loadList: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/work/project/weiXinHomeProjects')
      .then(function (res) {
        Indicator.close()
        _this.pjtLists = res.data
        _this.imgHeight = _this.$refs.imgele.height
      }).catch(function (response) {
        Indicator.close()
      })
    },
    toProjectDetail: function (project) {
      this.$router.push({path: '/project/projectDetail', query: { projectid: project.id }})
    },
    toMy: function (index) {
      if (index === 0) {
        this.$router.push({path: '/myDetail', query: { id: 1469 }})
      } else if (index === 1) {
        this.$router.push({path: '/myDetail', query: { id: 1385 }})
      } else if (index === 2) {
        this.$router.push({path: '/myDetail', query: { id: 1455 }})
      } else if (index === 3) {
        this.$router.push({path: '/myDetail', query: { id: 1354 }})
      }
    }
  },
  mixins: [global]
}
</script>


<style scoped>
.index{
  background-color: #f6f6f6;
}
.index .logo{
    width:100%;
    background:#f6f6f6;
    height: 45px;
    text-align:center;
    line-height:54px;
}
.logo img{
  width: 80px;
  height: auto;
  /* position: absolute;
  top: 15px;
  left: 15px; */
  z-index: 5;
}
.recommend{
  background-color: #f5f5f5;
  text-align: center;
  padding: 25px 0;
  display: table;
  width:100%;
}
.recommend .recommendlist{
  width: 70px;
  /* height: 70px; */
  border-radius:5px;
  -webkit-border-radius:5px;
  -moz-border-radius:5px;
  margin: 0 4px;
  display: table-cell;
  text-decoration: none;
  color:#333;
}
.recommend .recommendlist img{
    width:30px;
}
.selectbox{
    margin:0 10px;
    background-image:url('../assets/img/index/6.png');
    background-size:100% 100%;
    text-align:center;
}
.selectbox h1{
    color:#fff;
    padding:20px 0;
    font-weight: bold;
}
.selectbox h6{
    color:#fff;
    font-size:14px;
    padding:0 0 30px;
}
.selectbox .select{
    /* display:table; */
    padding:0 10px;
    display:flex;
    justify-content: space-between;
    padding-bottom: 20px;
    /* align-items: center; */
}
.selectbox .select .send{
    background:#fff;
    border-radius:10px;
    width:49%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.selectbox .select .send .introdce{
    display: inline-block;
    color: #333;
    font-size: 13px;
    word-break: keep-all;
    white-space: nowrap;
    -webkit-text-size-adjust: none;
    -webkit-transform: scale(0.8);
}
.selectbox .select .send .need{
    display: inline-block;
    font-size: 12px;
    color: #fff;
    background-image:url('../assets/img/index/7.png');
    padding: 4px 8px;
    background-size: 100% 100%;
    margin:18px 0;
}
 .btns{
    text-align: center;
    margin-top: 15px;
    margin-bottom: 13px;
  }
  .btns button{
    width: 91%;
    height: 30px;
    border: none;
    outline: none;
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
    margin: 0 5px;
    color: #fff;
    background:#1878fd;
    font-size: 12px;
  }
.expertbox{
    background:#fff;
    margin: 20px 10px 0;
    border-radius:10px;
    text-align:center;
}
.expertbox h1{
    color:#1878fd;
    font-weight: bold;
    font-size:22px;
    padding-top:30px;
}
.expertbox h6{
    padding-top:12px;
    color:#333;
    margin-bottom:20px;
}
.expertbox .expertlist{
    flex-wrap: wrap;
    display: flex;
    justify-content: space-around;
    padding-left: 4px;
}
.expertlist .listitem{
    width:47%;
    border-bottom:1px solid #ececec;
    margin-top: 10px;
    padding-bottom: 10px;
}
.expertlist .listitem img{
    width: 110px;
    height: 110px;
    border-radius: 50%;
    text-align: center;
    margin: 17px 0;
}
.expertlist .listitem .name{
    width:100%;
    color:#1878fd;
    font-weight:bold;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    text-align: left;
}
.listitem .info{
    color:#333;
    font-size:14px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    width:100%;
    height:38px;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: left;
}
.expertlist .listitem .classifybox{
    /* padding-bottom:20px; */
    overflow: hidden;
    max-height:22px;
    /* width:100%;
    white-space: nowrap; */
    /* text-overflow:ellipsis; */
    text-align: left;
}
.expertlist .listitem .classifybox .classify{
    display:inline-block;
    font-size: 12px;
    color: #4d8efd;
    background-color: #fff;
    border:1px solid #1878fd;
    padding: 0 5px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    margin-right:3px;
    height: 18px;
    line-height: 18px;
}
.designbox{
    margin-bottom: 70px;
}
.designbox .pjt_type{
    margin:20px 10px;
    overflow-x: auto;
    white-space: nowrap;
}
.pjt_type span{
    color:#333;
    min-width:66px;
    margin:0 12px;
}
.pjt_type .selected{
    color:#1878fd;
    font-weight: bold;
}
ul{
    background:#fff;
    border-radius:10px;
    padding:10px;
}
.projectList{
    display:flex;
    margin-top:14px;
    border-bottom:1px solid #ececec;
    justify-content: space-between;
    padding-bottom:10px;
}
.projectList .leftimg{
    width:40%;
    margin-right:20px;
    overflow:hidden;
    border-radius:10px;
    position:relative;
}
.projectList .leftimg img{
    width:100%;
    /* height:auto; */
}
.projectList .leftimg .recommend_Pjt{
    width: 50px;
    height: 24px;
    background: #1878fd;
    color: #fff;
    text-align: center;
    line-height: 24px;
    position: absolute;
    left: 0;
    top: 0;
    font-size:12px;
}
.projectList .rightinfo{
    width: 56%;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
}
.projectList .rightinfo h1{
    color:#333;
    font-weight: bold;
    font-size: 14px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    width:100%;
    height:38px;
}
.projectList .rightinfo .money{
    color:#f92222;
    font-weight: bold;
    font-size: 14px;
}
.projectList .rightinfo .people{
    color:#b5b5b5;
    font-size:12px;
}
.projectList .rightinfo .people span:nth-child(1){
    margin-right:20px;
}
.zhaomu{
  background-image:url('../assets/img/main_app/state-4.png');
}
.close{
  background-image:url('../assets/img/main_app/state-5.png');
}
.pjt_list li .jinxing{
  background-image:url('../assets/img/main_app/state-7.png');
}
.pjt_list li .over{
  background-image:url('../assets/img/main_app/state-8.png');
}
.pjt_list li .hezuo{
  background-image:url('../assets/img/main_app/state-6.png');
}
.pjt_list li .pingjia{
  background-image:url('../assets/img/main_app/state-9.png');
}

.mint-swipe{
  width: 100%;
  height: 160px;
  position: relative;
}
.titleImg{
  width: 100%;
}
.imgTitle{
  position: absolute;
  left: 15px;
  bottom:25px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// index.vue?74f5de86